const ITEMS = [
  "Hot & Gooey Cinnamon Rolls",
  "Biscuits & Savory Gravy",
  "Fresh Coffee & Vanilla Lattes",
  "Rolling To A Neighborhood Near You",
  "Life Is Better With A Bun",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center font-display font-semibold uppercase tracking-wide text-sm sm:text-base whitespace-nowrap">
        <span className="px-5">{item}</span>
        <svg viewBox="0 0 24 24" className="w-5 h-5 shrink-0" fill="#111111">
          <path d="M12 0 L14.5 8 L23 6 L16.5 12 L23 18 L14.5 16 L12 24 L9.5 16 L1 18 L7.5 12 L1 6 L9.5 8 Z" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = ({ bg = "bg-cb-pink", text = "text-white", reverse = false, border = true }) => (
  <div
    data-testid="marquee-ribbon"
    className={`${bg} ${text} ${border ? "border-y-3 border-cb-black" : ""} overflow-hidden py-3 select-none`}
    aria-hidden="true"
  >
    <div className={`marquee-track ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}>
      <Row />
      <Row />
    </div>
  </div>
);
